export default "__VITE_ASSET__ccb35ea2__"